import Pusher from 'pusher-js';
import { useEffect, useState } from 'react';
import { publicEnvConfig } from 'helpers/env';

const usePusher = (channelName, events, callback, data) => {
	const [pusherChannel, setPusherChannel] = useState();
	useEffect(() => {
		let pusher;
		if (publicEnvConfig.PUSHER_ENABLED && channelName && events.length) {
			try {
				pusher = new Pusher(publicEnvConfig.PUSHER_APP_KEY, {
					encrypted: true,
					authEndpoint: `${publicEnvConfig.RESTURL_BASE}/pusher/auth`,
				});
				const channel = pusher.subscribe(channelName);
				setPusherChannel(channel);
			} catch (e) {
				console.error(
					'error creating pusher instance. Key is missing, it could be an error decrypting the .env file',
					e,
				);
			}
		}

		return () => {
			if (pusher) {
				pusher.disconnect();
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (pusherChannel && pusherChannel.bind) {
			events.forEach((event) => {
				pusherChannel.unbind(event);
				pusherChannel.bind(event, callback);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pusherChannel, data]);
};

export default usePusher;
